define('presentation/settings/accountProfile/facades/accountProfileFacade',['businessServices/converters/textConverter',
        'common/converters/accountNumberFormatter',
        'common/promises/promiseFactory',
        'externalDependencies/clientWebSocket',
        'persistence/webSocket/webSocketApp'
], function() {

    const PromiseFactoryConstructor = require('common/promises/promiseFactory');
    const _promiseFactory = new PromiseFactoryConstructor();

    const AccountNumberFormatterConstructor = require('common/converters/accountNumberFormatter');
    const _accountNumberFormatter = new AccountNumberFormatterConstructor();

    const TextConverterConstructor = require('businessServices/converters/textConverter');
    const _textConverter = new TextConverterConstructor();

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const _billingProfileWebSocket = clientWebSocket.forApplication("billingProfile");


    let _webSocketApp = null;

    const _cleanResultData = (dataObject) => {
        for (let property in dataObject) {
            if (dataObject[property] === null || dataObject[property] === undefined || dataObject[property] === "undefined") {
                dataObject[property] = "";
            }
        }
    };

    const _saveAccountProfile = (accountProfile) => {
        return _promiseFactory.defer((promise) => {
            const request = {
                howWillYouUseTresta: accountProfile.howWillYouUseTresta,
                accountHolderFirstName:  accountProfile.accountHolderFirstName,
                accountHolderLastName: accountProfile.accountHolderLastName,
                businessName: accountProfile.businessName,
                addressLineOne: accountProfile.addressLineOne,
                addressLineTwo: accountProfile.addressLineTwo,
                city: accountProfile.city,
                stateProvince: accountProfile.stateProvince,
                postalCode: _textConverter.removeAllWhiteSpaces(accountProfile.postalCode),
                country: accountProfile.country,
                phoneNumber: accountProfile.phoneNumber,
                pointOfContactFirstName: accountProfile.pointOfContactFirstName,
                pointOfContactLastName: accountProfile.pointOfContactLastName,
                timeZone: accountProfile.timeZone,
                industry: accountProfile.industry,
                monthYearFounded: accountProfile.inBusinessSince,
                websiteUrl: accountProfile.websiteUrl,
                companySize: accountProfile.numberOfEmployees,
                billingCommunications: accountProfile.billingCommunications,
            };

            _webSocketApp.send("set_account_profile", request, (result) => {
                promise.resolve(result);
            });
        });
    };

    const _getAccountProfile = () => {
        return _promiseFactory.defer((deferredObject) => {
            _billingProfileWebSocket.send("getBillingProfile", {}, (response) => {
                response.accountNumber = _accountNumberFormatter.formatAccountNumber(response.accountNumber);
                _cleanResultData(response);
                deferredObject.resolve(response);
            });
        });
    };

    const _hasNumberPortsInProgress = () => {
        return _promiseFactory.deferIndefinitely((deferredObject) => {
            _webSocketApp.send("has_number_ports_in_progress", {}, (result) => {
                if (result) {
                    deferredObject.resolve(result.hasNumberPortsInProgress);
                } else {
                    deferredObject.resolve(false);
                }
            });
        });
    };


    const _init = () => {
        const WebSocketAppConstructor = require('persistence/webSocket/webSocketApp');
        _webSocketApp = new WebSocketAppConstructor();
        _webSocketApp.init("account_profile");
    };

    return function() {
        const self = this;

        self.init = _init;
        self.hasNumberPortsInProgress = _hasNumberPortsInProgress;
        self.getAccountProfile = _getAccountProfile;
        self.saveAccountProfile = _saveAccountProfile;
    };
});
